module.exports = __webpack_public_path__ + "images/3d-people-ca1823bce73d26b97525f91f6901f153.jpg";